import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";

export function CommonGraph({
  title,
  unit,
  formattedDates,
  graphData,
  graphKey,
}) {
  const [dataSets, setDataSets] = useState([]);

  function getDataValues(array, key) {
    return array.map((obj) => obj[key]);
  }

  function generateRandomColorCode() {
    // Generate a random hexadecimal number
    var randomColorCode = Math.floor(Math.random() * 16777215).toString(16);

    // Pad the color code with zeros if necessary
    while (randomColorCode.length < 6) {
      randomColorCode = "0" + randomColorCode;
    }

    // Prepend a hash symbol (#) to the color code
    randomColorCode = "#" + randomColorCode;

    return randomColorCode;
  }

  const handleMakeData = () => {
    let temporaryData = [];
    Object.keys(graphData).forEach((element, index) => {
      temporaryData.push({
        label: element,
        data: getDataValues(graphData[element], graphKey),
        fill: false,
        tension: 0,
        borderColor: generateRandomColorCode(),
        borderWidth: 2,
      });
    });

    setDataSets(temporaryData);
  };

  const data = {
    labels: formattedDates,
    datasets: dataSets,
  };

  const options = {
    maintainAspectRatio: false,
    aspectRatio: 1.0,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#AFB8B7",
          usePointStyle: true,
          pointStyle: "circle",
          padding: 20,
          pointBackgroundColor: "white",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#AFB8B7",
        },
        grid: {
          color: "#ECECEC",
          borderWidth: 1,
        },
      },
      y: {
        ticks: {
          color: "#AFB8B7",
        },
        grid: {
          color: "#ECECEC",
          borderWidth: 1,
        },
      },
    },
  };

  useEffect(() => {
    if (graphData && Object.keys(graphData).length > 0) {
      handleMakeData();
    }
  }, [graphData]);

  const handleKgLabel = () => {
    return (
      <span className="graphHeading">
        Energy Consumed per Vehicle (L, kWh, kgH<sub>2</sub>, etc)
      </span>
    );
  };

  const handleKgUnit = () => {
    return (
      <span>
        kgH<sub>2</sub>
      </span>
    );
  };

  return (
    <div className="graphDisplay">
      <div
        style={{
          width: "70px",
          position: "relative",
          top: "160px",
          transform: "rotate(270deg)",
          right: "25px",
        }}
      >
        {unit === "kgH2" ? handleKgUnit() : unit}
      </div>
      <div className="graphHeader">
        <strong>
          {title === "kgH2" ? (
            handleKgLabel()
          ) : (
            <span className="graphHeading">{title}</span>
          )}
        </strong>
      </div>

      <div className="graphBox">
        <Chart type="line" data={data} options={options} />
      </div>
    </div>
  );
}
